import personal from '@/view/personal/center'
const personalRouter = [
  {
    path: '/personal/center.html',
    name: 'personal-center',
    component: personal,
    meta: {
      title: '个人中心'
    }
  },
]

export default personalRouter



// WEBPACK FOOTER //
// ./src/router/personal/personal.js